import getCustomFormat from './getCustomFormat';

import type { Locales } from '@monoimin/sb-types';

type StoryDates = {
  updatedAt: string | null | undefined;
  publishedAt: string | null | undefined;
  firstPublishedAt: string | null | undefined;
};

/**
 * Функция для получения даты публикации статьи (которая выводится визуально в вёрстке) согласно приоритетам.
 *
 * @param updatedAt - 1-ый приоритет. РУЧНОЕ установление даты в редакторе сториблока.
 *
 * @param publishedAt - 2-ой приоритет. Дата, которая обновляется при клике на кнопку Publish в редакторе сториблока. Является сервисным полем стори - published_at.
 *
 * @param firstPublishedAt - 3-ий приоритет. Выводим в том случае, если это единственная дата и это новая статья. Является сервисным полем стори - first_published_at.
 *
 * @param locale - Текущая локаль.
 *
 * @returns Возвращает одну из переданных дат в отформатированном виде.
 */
export const getPublicationDate = ({
  updatedAt,
  publishedAt,
  firstPublishedAt,
  locale,
}: StoryDates & {
  locale: Locales;
}): string => {
  if (!updatedAt && !publishedAt && !firstPublishedAt) {
    return '';
  }
  const format = getCustomFormat(locale);

  const date = format(updatedAt || '', undefined, undefined, {
    function: 'getPublicationDate',
  });

  if (date) {
    return date;
  }

  return getPublicationDate({
    updatedAt: publishedAt,
    publishedAt: firstPublishedAt,
    firstPublishedAt: null,
    locale: locale,
  });
};

export default getPublicationDate;
